import store from '@/store/store';
import Env from '@/env';
/**
 * Route must be authenticate, if user is authenticated, push them to home
 */
export default async function visitorAgeVerify({ next, router, to }) {
  let queries = to.query
  if(queries.access_type){
    return router.push({ name: 'HomePage',  params: {business_slug: Env.defaultBusinessSlug}, query: { access_type: queries.access_type } });
  } else {
    return router.push({ name: 'HomePage',  params: {business_slug: Env.defaultBusinessSlug }  });
  }
}
